import { FETCHING, GET_REPORTS, ADD_NEW_ERROR } from '../constants/actionTypes'
import { Action } from 'redux'
import environment from '../../environment'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'

const serverUrl = environment._serverUrl
export const getUserStatistics =
  ({ token }: { token: string }): ThunkAction<void, unknown, unknown, Action> =>
  async (dispatch: ThunkDispatch<unknown, unknown, Action>): Promise<void> => {
    dispatch({ type: FETCHING, payload: true })
    try {
      const getReports = await fetch(serverUrl + 'admin/user-counts', {
        method: 'GET',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        referrerPolicy: 'no-referrer',
      })
      const status = await getReports.status

      if (status === 200) {
        const reports = await getReports.json()
        console.log('API response:', reports)
        dispatch({ type: GET_REPORTS, payload: reports })
        dispatch({ type: FETCHING, payload: false })
      } else if (status === 204) {
        dispatch({ type: ADD_NEW_ERROR, payload: '204: No reports found' })
        dispatch({ type: FETCHING, payload: false })
      } else {
        dispatch({ type: ADD_NEW_ERROR, payload: status.toString() })
        dispatch({ type: FETCHING, payload: false })
      }
    } catch (ex) {
      console.error('Error', ex)
    }
    return
  }
